export const FoxEnvs = Object.freeze({
    dev: {
        authDomain: "metosin.eu.auth0.com",
        authClientId: "mNIyNYb0fyD6N39Uzbn52L5phwWIEna7",
        publicApiAudience: "public-foxeriot-api",
        baseUrl: "https://backend-dev.foxeriot.com"
    },
    prod: {
        authDomain: "foxeriot.eu.auth0.com",
        authClientId: "woVI8wMnYOaDmRvDHu7rXuS667qiwBwt",
        publicApiAudience: "https://backend.foxeriot.com/api/",
        baseUrl: "https://backend.foxeriot.com"
    }
});


// WEBPACK FOOTER //
// ./src/app/service/foxeriot_environments.js